<template>
  <div class="thai-hilo-result-history">
    <Row type="flex">
      <Col id="thai-hilo-history-fanone" class="thai-hilo-history-bar">
        {{$t('thai_hilo.o1')}} -
        <span>{{ this.highPercentage }}%</span>
      </Col>
      <Col id="thai-hilo-history-fantwo" class="thai-hilo-history-bar">
        {{$t('thai_hilo.o2')}} -
        <span>{{ this.lowPercentage }}%</span>
      </Col>
      <Col id="thai-hilo-history-fantwo" class="thai-hilo-history-bar">
        {{$t('thai_hilo.triple')}} -
        <span>{{ this.triplePercentage }}%</span>
      </Col>
      <Col id="thai-hilo-history-fantwo" class="thai-hilo-history-bar">
        {{$t('thai_hilo.o3group')}} -
        <span>{{ this.ehlPercentage }}%</span>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col class="thai-hilo-history-trend-lot-col" v-for="(col, index) in this.newArr" :key="index">
        <div
          class="thai-hilo-history-trend-lot-cell"
          :class="getVal(cell[0])"
          v-for="(cell, index) in col"
          :key="index"
        >
          <thai-hilo-history-popper
            :game="game"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
          >{{ getVal(cell[0]) }}</thai-hilo-history-popper>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { TimelineMax } from "gsap";
import ThaiHiloHistoryPopper from "../widgets/ThaiHiloHistoryPopper";

export default {
  props: ["historicalData", "game", "gameCode", "gameId"],
  components: {
    Row,
    Col,
    ThaiHiloHistoryPopper
  },
  data() {
    return {
      tempArr: [],
      newArr: [],
      totalRow: 18,
      highPercentage: 0,
      lowPercentage: 0,
      triplePercentage: 0,
      ehlPercentage: 0,
      previousBadgeCount: 0
    };
  },
  methods: {
    getVal(value) {
      if (value == "0100") return this.$t("thai_hilo.o2_trend");
      else if (value == "1000") return this.$t("thai_hilo.o1_trend");
      else if (value == "0010") return "T";
      else return "11";
    }
  },
  watch: {
    historicalData() {
      this.tempArr = [];
      this.highPercentage = 0;
      this.lowPercentage = 0;
      let tempData = [...this.historicalData];
      let index = 0;

      for (var i = 0; i < tempData.length; i++) {
        if (tempData[i]["high"] == "1") this.highPercentage++;
        if (tempData[i]["low"] == "1") this.lowPercentage++;
        if (tempData[i]["triple"] == "1") this.triplePercentage++;
        if (tempData[i]["ehl"] == "1") this.ehlPercentage++;

        let temp = [];
        let hl =
          tempData[i]["high"] +
          tempData[i]["low"] +
          tempData[i]["triple"] +
          tempData[i]["ehl"];

        temp.push(hl);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        temp.push(
          tempData[i]["dice1"],
          tempData[i]["dice2"],
          tempData[i]["dice3"]
        );
        temp.push(tempData[i]["high"], tempData[i]["low"]);
        temp.push(tempData[i]["triple"], tempData[i]["ehl"]);

        this.tempArr.push(temp);
      }
      this.tempArr.reverse();

      (index = 0),
        (this.newArr = this.tempArr.reduce((result, data, i, array) => {
          if (
            !array[i - 1] ||
            data[index] !== array[i - 1][index] ||
            result[result.length - 1].length === 5
          )
            result.push([]);
          result[result.length - 1].push(data);
          return result;
        }, []));

      this.newArr.reverse();
      this.newArr.splice(this.totalRow);
      this.newArr.reverse();
    }
  },
  mounted() {
    // console.log(this.historicalData);
  }
};
</script>

<style lang="scss" scoped>
.thai-hilo-history-trend-lot-cell {
  color: #ffffff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}

.thai-hilo-history-trend-lot-cell.L {
  background: #4ebaf1;
}

.thai-hilo-history-trend-lot-cell.H {
  background: #ff5050;
}

.thai-hilo-history-trend-lot-cell.T {
  background: #752268;
}

.thai-hilo-history-trend-lot-cell.\31\31 {
  background: #454545;
}
</style>

<style lang="scss">
.thai-hilo-history-bar {
  flex: 0.2 1 auto;
  color: rgb(0, 0, 0);
  background-color: rgb(239, 242, 248);
  padding: 4px 12px;
  margin: 2px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
</style>